'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import React, { useEffect, useRef } from 'react';
export const CAT_BANNER_ICON_TYPES = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning'
};
export const AssociatedDealerBanner = ({ heading, variant, ignoreScroll = false, children }) => {
    const { SUCCESS, WARNING, ERROR } = CAT_BANNER_ICON_TYPES;
    const ref = useRef(null);
    useEffect(() => {
        if (ref.current && variant === ERROR && !ignoreScroll) {
            ref.current.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }, [ref, variant, ignoreScroll, ERROR]);
    return (_jsxs(CatInlineNotification, { heading: heading, variant: variant, "data-testid": "cat-banner", ref: ref, children: [variant === ERROR ? (_jsx(CatIconWarningCircle, { slot: "before", "data-testid": "error-icon", className: "mt-1" })) : null, variant === SUCCESS ? (_jsx(CatIconSuccess, { slot: "before", "data-testid": "success-icon", className: "mt-1" })) : null, variant === WARNING ? (_jsx(CatIconWarningTriangle, { slot: "before", "data-testid": "warning-icon", className: "mt-1" })) : null, _jsx("span", { className: "align-middle cat-u-theme-typography-body-sm u-color--ExtraDarkGray", children: children })] }));
};
